import type { SpResponse } from '@backend-models/common/request/sp-response'
import type { ConfigurationResponse } from '@backend-models/configuration/configuration-response'

// Application config
export const appConfig = {
  api: import.meta.env.VITE_API || `${window.location.origin}/api`,
  appTitle: import.meta.env.VITE_APP_TITLE || 'Acquisition Management Platform',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0-alpha',
} as const

// Public config memory
let publicConfig: ConfigurationResponse | null = null

/**
 * Returns public config for the application. Can be reloaded if necessary
 * @param reload
 * @returns ConfigurationResponse
 */
export const getPublicConfig = async (reload = false) => {
  if (!reload && publicConfig) {
    return publicConfig
  }
  try {
    const req = await fetch(`${appConfig.api}/public/configuration`)
    const res = (await req.json()) as SpResponse<ConfigurationResponse>
    if (!res.success) {
      throw new Error(res.errors?.join(','))
    }
    publicConfig = res.data
    return publicConfig
  } catch (error) {
    console.error(`Could not load public config`, error)
    throw error
  }
}
